import { memo, useCallback } from 'react'
import { getTextareaClasses } from '../../styles/inputStyles'
import StarRating from './StarRating'

/**
 * ReviewForm - Write or edit a review (rating + optional comment)
 * @atomic
 */
const ReviewForm = memo(function ReviewForm({
  rating, setRating, content, setContent,
  editingReview, onSubmit, onCancel, loading, t
}) {
  const isEditing = !!editingReview
  const hasInput = rating > 0 || content.trim().length > 0

  const handleSubmit = useCallback((e) => {
    e.preventDefault()
    if (hasInput && !loading) onSubmit()
  }, [hasInput, loading, onSubmit])

  const handleCancel = useCallback((e) => {
    e.preventDefault()
    onCancel()
  }, [onCancel])

  return (
    <form onSubmit={handleSubmit} className="mb-3 pb-3 border-b border-gray-100">
      <div className="mb-3">
        <StarRating rating={rating} onChange={setRating} size="md" />
      </div>
      <div className="mb-2">
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder={t('review.commentPlaceholder', 'Share your experience...')}
          rows={3}
          className={getTextareaClasses(false)}
          maxLength={1000}
        />
      </div>
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={!hasInput || loading}
          className="flex-1 py-1.5 px-3 bg-primary text-white text-xs font-semibold rounded-lg disabled:opacity-50 transition-opacity"
        >
          {loading
            ? t('common.loading', 'Loading...')
            : isEditing
              ? t('review.updateReview', 'Update Review')
              : t('review.submitReview', 'Submit Review')
          }
        </button>
        {isEditing && (
          <button
            type="button"
            onClick={handleCancel}
            onTouchEnd={handleCancel}
            className="px-3 py-1.5 text-xs font-semibold text-gray-500 hover:text-gray-700 rounded-lg border border-gray-200 transition-colors"
          >
            {t('common.cancel', 'Cancel')}
          </button>
        )}
      </div>
    </form>
  )
})

export default ReviewForm
